import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { BoardStatusSegments, UUID } from "@/lib/types";

/** Per-row cycle-time segments for the Zeitleiste segmented bar. Only fetched
 * when enabled (ticket boards on the timeline view). Live refresh piggybacks on
 * useBoard invalidating this key on cell.updated / row.* WS events. */
export function useBoardStatusSegments(boardId: UUID | undefined, enabled: boolean) {
  const q = useQuery({
    enabled: Boolean(boardId) && enabled,
    queryKey: boardId
      ? queryKeys.boardStatusSegments(boardId)
      : ["boards", "void", "status-segments"],
    queryFn: () => api.getBoardStatusSegments(boardId as UUID),
  });
  return (q.data ?? {}) as BoardStatusSegments;
}
